import type { ExecutionCandle } from "../types/trade";

/** BE may send ISO strings or unix seconds/ms on `time` / `timestamp` / `t`. */
export function normalizeExecutionCandleTime(raw: unknown): string | null {
  if (raw == null) return null;
  if (typeof raw === "string" && raw.trim()) return raw.trim();
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const ms = raw > 1e12 ? raw : raw * 1000;
    return new Date(ms).toISOString();
  }
  return null;
}

type ExecutionCandleRow = ExecutionCandle & { timestamp?: unknown; t?: unknown };

/** Map BE candle rows onto the `time` field ExecutionCandlesChart expects. */
export function normalizeExecutionCandles(list: ExecutionCandle[]): ExecutionCandle[] {
  return list.map((c) => {
    const row = c as ExecutionCandleRow;
    const time =
      normalizeExecutionCandleTime(c.time) ??
      normalizeExecutionCandleTime(row.timestamp) ??
      normalizeExecutionCandleTime(row.t);
    return { ...c, time };
  });
}

/** First usable bar timestamp from a candle row (`time` or BE `timestamp`). */
export function executionCandleRowTime(
  c: ExecutionCandle | null | undefined
): string | null {
  if (!c) return null;
  const row = c as ExecutionCandleRow;
  return (
    normalizeExecutionCandleTime(c.time) ??
    normalizeExecutionCandleTime(row.timestamp) ??
    normalizeExecutionCandleTime(row.t)
  );
}
